import { CTAButton } from '@/components/cta/CTAButton';
import { CTA } from '@/types/sanity';
import { cn } from '@/lib/utils';

interface SectionCTAsProps {
  ctas?: CTA[];
  justify?: 'center' | 'start';
  size?: 'default' | 'sm' | 'lg';
}

export function SectionCTAs({ ctas, justify = 'center', size = 'default' }: SectionCTAsProps) {
  if (!ctas || ctas.length === 0) return null;

  return (
    <div
      className={cn(
        'flex gap-4 mt-8 flex-wrap',
        justify === 'start' ? 'justify-start' : 'justify-center'
      )}
    >
      {ctas.map((cta) => (
        <CTAButton key={cta._id} cta={cta} size={size} />
      ))}
    </div>
  );
}
